import Pressable from '@/components/motion/pressable';
import { cn } from '@/lib/utils';
import { ChevronRightIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface SenderNavRowProps {
	label: string;
	onClick: () => void;
	description?: string;
	trailing?: ReactNode;
	className?: string;
}

export default function SenderNavRow({ label, onClick, description, trailing, className }: SenderNavRowProps) {
	return (
		<Pressable
			role='button'
			tabIndex={0}
			onClick={onClick}
			className={cn(
				'flex min-h-11 w-full items-center justify-between gap-3 rounded-xl border border-border/60 bg-card/40 px-3 py-2.5 text-left active:bg-accent/30',
				className,
			)}
		>
			<div className='min-w-0 flex-1'>
				<p className='text-[15px]'>{label}</p>
				{description ? <p className='text-[13px] text-muted-foreground truncate'>{description}</p> : null}
			</div>
			{trailing ?? <ChevronRightIcon size={18} className='shrink-0 text-muted-foreground' />}
		</Pressable>
	);
}
